import { endOfSkippable } from "./end-of-skippable";

/** Index just past the `}` closing the object at `open`, or -1 if unbalanced. */
export function endOfObjectLiteral(source: string, open: number): number {
  let depth = 0;
  for (let at = open; at < source.length; at += 1) {
    const skipped = endOfSkippable(source, at);
    if (skipped !== at) {
      at = skipped;
      continue;
    }
    if (source[at] === "{") depth += 1;
    else if (source[at] === "}" && (depth -= 1) === 0) return at + 1;
  }
  return -1;
}
